<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
      <div class="headerText">
          <div class="label">
            {{'ENTITYDETAILS.unit' | translate}}
          </div>
          <div class="help">
            <app-help [helpData]="helpData" ></app-help>
          </div>
          <div class="submitButton" (click)="openAddUnitModal();">
            <div class="button">
              {{'ENTITYDETAILS.addUnit' | translate}}
            </div>
        </div>
      </div>
    <div class="entityTable">
      <table mat-table *ngIf="entityArray.length" [dataSource]="entityArray" class="loadTable">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'ENTITYDETAILS.name' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef class="customHeader">{{'ENTITYDETAILS.address' | translate}} </th>
          <td mat-cell *matCellDef="let element" style="width: 100px;"> {{element.address}} </td>
        </ng-container>


        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef class="customHeader">{{'ENTITYDETAILS.city' | translate}} </th>
          <td mat-cell *matCellDef="let element" style="width: 100px;"> {{element.city}} </td>
        </ng-container>

        <ng-container matColumnDef="features">
          <th mat-header-cell *matHeaderCellDef class="customHeader">{{'ENTITYDETAILS.features' | translate}} </th>
          <td mat-cell *matCellDef="let element" class="padding" style="width: 100px;">
            <span *ngFor="let item of element.features; let i=index">
              {{item.name}}
              <span *ngIf="(element.features.length > 1) && (i != element.features.length-1)">,<br></span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="subFeatures">
          <th mat-header-cell *matHeaderCellDef class="customHeader">{{'ENTITYDETAILS.subFeatures' | translate}}</th>
          <td mat-cell *matCellDef="let element" class="padding" style="width: 100px;">
            <span *ngFor="let item of element.subFeatures; let i=index">
              {{item.name}}
              <span *ngIf="(element.subFeatures.length > 1) && (i != element.subFeatures.length-1)">,<br></span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> </th>
          <td mat-cell *matCellDef="let element" style="width: 100px;">
            <div class="buttons">
              <div class="button">
                <mat-select [placeholder]="'ENTITYDETAILS.actions' | translate">
                  <mat-option (click)="editUnit(element);" ><img style="width: 16px;position: relative;top: 3px;" src="assets/icon-edit.svg"   alt=""> {{'ENTITYDETAILS.edit' | translate}}</mat-option>
                  <!-- <mat-option><img style="width: 16px;position: relative;top: 3px;" src="assets/icon-block.svg"   alt=""> {{'UNITMANAGEMENT.block' | translate}}</mat-option> -->
                </mat-select>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="entityColumns;sticky: true" style="font-weight: bold !important;"></tr>
        <tr mat-row *matRowDef="let row; columns: entityColumns;"></tr>
      </table>
    </div>
  </div>

</div>